module.exports = __webpack_public_path__ + "static/media/traiterome.7faefdc3.jpg";